module.exports = __webpack_public_path__ + "static/media/zkamil-system-architekt.44eeb96b.png";